import {useNavigate, useParams} from 'react-router-dom';

import {LoadingPlaceholder} from 'src/components';
import {NodeDetailParams} from 'src/types';
import {CODELOGIC_UI_PATH as UI_PATH} from 'src/config';
import {useNode} from 'src/hooks';

import {NodeDetail} from './NodeDetail';

import './styles.css';

export const NodeDetailPage = () => {
  const navigate = useNavigate();
  const {nodeId} = useParams<NodeDetailParams>();

  const {loading, node} = useNode(nodeId);

  const goToNode = (id: string) => {
    if (id !== nodeId) navigate(`${UI_PATH}/node/${id}`);
  };

  return (
    <div className="NodeDetailContainer">
      {loading || !node ? <LoadingPlaceholder /> : <NodeDetail node={node} goToNode={goToNode} />}
    </div>
  );
};
